(() => {
  const container = document.querySelector('[data-store-currency]');
  if (!container || container.dataset.designMode === 'true') return;
  const form = container.querySelector('form');
  const country = form?.querySelector('[name="country_code"]');
  if (!form || !country || container.dataset.country === 'GB') return;
  const returnInput = form.querySelector('[name="return_to"]');
  if (returnInput) returnInput.value = location.pathname + location.search + location.hash;
  try {
    const attempt = `${container.dataset.country}:GB`;
    if (sessionStorage.getItem('luvly-currency-attempt') === attempt) return;
    sessionStorage.setItem('luvly-currency-attempt', attempt);
    sessionStorage.setItem('luvly-currency-choice', 'GB');
    sessionStorage.setItem('luvly-currency-auto', 'GB');
  } catch {
    return;
  }
  country.value = 'GB';
  form.submit();
})();
